const data = [
    {
        name: "AngelList",
        description: "",
        filter:"populars",
        link: "https://angel.co",
        image:"./images/angel.jpg",
        id: '1'
    },
    {
        name: "Mashable",
        description: "",
        filter:"populars",
        link: "http://jobs.mashable.com/jobs",
        image:"./images/mashable.jpg",
        id: '2'
    },
    {
        name: "Stack Overflow",
        description: "",
        filter:"populars",
        link: "http://stackoverflow.com/jobs",
        image:"./images/stov.png",
        id: '3'
    },
    {
        name: "Linked in",
        description: "",
        filter:"populars",
        link: " http://linkedIn.com",
        image:"./images/li.png",
        id: '4'
    },
    {
        name: "Glassdoor",
        description: "",
        filter:"populars",
        link: "http://glassdoor.com",
        image:"./images/glasdoor.png",
        id: '5'
    },
    {
        name: "Dice",
        description: "",
        filter:"populars",
        link: "http://dice.com",
        image:"./images/dice.png",
        id: '6'
    },

    {
        name: "Monster",
        description: "",
        filter:"populars",
        link: "http://monster.com",
        image:"./images/monster.png",
        id: '7'
    },
    {
        name: "Simply Hired",
        description: "",
        filter:"populars",
        link: "http://simplyhired.com",
        image:"./images/sh.png",
        id: '8'
    },
    {
        name: "Toptal",
        description: "",
        filter:"populars",
        link: "https://toptal.com",
        image:"./images/toptal.jpg",
        id: '9'
    },
    {
        name: "Hired",
        description: "",
        filter:"populars",
        link: "https://hired.com",
        image:"./images/hired.png",
        id: '10'
    },
    {
        name: "The Ladders",
        description: "",
        filter:"populars",
        link: "https://www.theladders.com/",
        image:"./images/tl.png",
        id: '11'
    },
    {
        name: "CrunchBoard",
        description: "",
        filter:"populars",
        link: "https://www.crunchboard.com/jobs",
        image:"./images/cb.png",
        id: '12'
    },
    {
        name: "RemoteOk",
        description: "",
        filter:"remote",
        link: "http://remoteok.io/",
        image:"./images/ro.png",
        id: '13'
    },
    {
        name: "Stackoverflow Remote",
        description: "",
        filter:"remote",
        link: "http://stackoverflow.com/jobs/remote-developer-jobs",
        image:"./images/stov.png",
        id: '14'
    },
    {
        name: "FlexJobs",
        description: "",
        filter:"remote",
        link: "http://flexjobs.com",
        image:"./images/fj.png",
        id: '15'
    },
    {
        name: "WeWorkRemotely",
        description: "",
        filter:"remote",
        link: "http://weworkremotely.com",
        image:"./images/wwr.jpg",
        id: '16'
    },
    {
        name: "Working Nomads",
        description: "",
        filter:"remote",
        link: "http://workingnomads.co/remote-development-jobs",
        image:"./images/wn.jpg",
        id: '17'
    },
    {
        name: "Remote.co",
        description: "",
        filter:"remote",
        link: "https://remote.co/remote-jobs/developer/",
        image:"./images/rco.png",
        id: '18'
    },
    {
        name: "Remoters",
        description: "",
        filter:"remote",
        link: "http://remoters.net/jobs/software-development",
        image:"./images/remoters.png",
        id: '19'
    },
    {
        name: "JS Remotely",
        description: "",
        filter:"remote",
        link: "http://jsremotely.com",
        image:"./images/jsr.jpg",
        id: '20'
    },
    {
        name: "Front-end remote",
        description: "",
        filter:"remote",
        link: "http://frontendremotejobs.com",
        image:"./images/fe.png",
        id: '21'
    },
    {
        name: "DailyRemote",
        description: "",
        filter:"remote",
        link: "https://dailyremote.com",
        image:"./images/drem.png",
        id: '22'
    },
    {
        name: "Remotive",
        description: "",
        filter:"remote",
        link: "https://remotive.io/remote-jobs/software-dev",
        image:"./images/remotive.png",
        id: '23'
    },
    {
        name: "Outsourcely",
        description: "",
        filter:"remote",
        link: "http://outsourcely.com/remote-web-development-jobs",
        image:"./images/outs.png",
        id: '24'
    },
    {
        name: "Pangian",
        description: "",
        filter:"remote",
        link: "https://pangian.com/job-travel-remote",
        image:"./images/pangian.jpg",
        id: '25'
    },
    {
        name: "Remote Talent",
        description: "",
        filter:"remote",
        link: "http://remotetalent.co/jobs",
        image:"./images/rt.png",
        id: '26'
    },
    {
        name: "JustRemote",
        description: "",
        filter:"remote",
        link: "https://justremote.co/remote-developer-jobs",
        image:"./images/jr.png",
        id: '27'
    },
    {
        name: "Remote Leaf",
        description: "",
        filter:"remote",
        link: "https://remoteleaf.com",
        image:"./images/rl.png",
        id: '28'
    },
    {
        name: "SitePoint",
        description: "",
        filter:"remote",
        link: "https://sitepoint.com/jobs/",
        image:"./images/sitep.png",
        id: '29'
    },
    {
        name: "JsJobbs",
        description: "",
        filter:"remote",
        link: "https://jsjobbs.com/remote-javascript-jobs/",
        image:"./images/jsjobbs.png",
        id: '30'
    },
    {
        name: "Product Hunt",
        description: "",
        filter:"startups",
        link: "http://producthunt.com/jobs",
        image:"./images/ph.png",
        id: '31'
    },
    {
        name: "Startup Hire",
        description: "",
        filter:"startups",
        link: "http://startuphire.com",
        image:"./images/sth.png",
        id: '32'
    },
    {
        name: "Startup Jobs",
        description: "",
        filter:"startups",
        link: "https://startup.jobs",
        image:"./images/sj.png",
        id: '33'
    },
    {
        name: "Startupers",
        description: "",
        filter:"startups",
        link: " http://startupers.com",
        image:"./images/sters.jpg",
        id: '34'
    },
    {
        name: "Y Combinator Jobs",
        description: "",
        filter:"startups",
        link: "http://news.ycombinator.com/jobs",
        image:"./images/yc.png",
        id: '35'
    },
    {
        name: "JrDevJobs",
        description: "",
        filter:"junior",
        link: "http://jrdevjobs.com",
        image:"./images/jrj.png",
        id: '36'
    },
    {
        name: "Stackoverflow Junior Jobs",
        description: "",
        filter:"junior",
        link: "https://stackoverflow.com/jobs/junior-developer-jobs",
        image:"./images/stov.png",
        id: '37'
    }
]

export default data